<template>
  <div class="about-page container py-5">
    <div class="card shadow-lg border-0 rounded-4 p-4">
      <div class="row align-items-center">
        <!-- Profile Image -->
        <div class="col-md-4 text-center mb-3 mb-md-0">
          <img
            src="/images/unais.png"
            alt="Profile"
            class="rounded-circle img-fluid profile-img shadow"
          />
        </div>

        <!-- About Content -->
        <div class="col-md-8">
          <h2 class="mb-3 text-primary">About Me</h2>
          <p class="text-muted">
            I am <strong>Unais VM</strong>, a passionate Full Stack Developer specializing in building and deploying scalable web applications. With over 6 years of professional experience, my core expertise lies in PHP, Laravel, MySQL, RESTful APIs, and modern frontend technologies like JavaScript, Vue.js, and React.js.
          </p>
          <p class="text-muted">
           Throughout my career, I have engineered diverse solutions, including enterprise CRM platforms, e-commerce ecosystems, and AI-driven automation tools. Having worked with companies like SkyuniTech (Dubai), PromptTech Global, and Voyager IT Solutions, I have successfully delivered over 10+ custom applications and dynamic CMS platforms.
          </p>
          <p class="text-muted">
            I love handling the complete development lifecycle—from optimizing complex database structures to managing cloud deployments using AWS, Docker, and Linux servers. I thrive in collaborative team environments and am dedicated to writing clean, maintainable code that creates seamless, impactful digital experiences.
          </p>

          <!-- Skills Badges -->
          <div class="mt-3">
            <span class="badge bg-primary me-2 mb-2">Laravel</span>
            <span class="badge bg-success me-2 mb-2">PHP</span>
            <span class="badge bg-warning text-dark me-2 mb-2">MySQL</span>
            <span class="badge bg-info text-dark me-2 mb-2">React.js</span>
            <span class="badge bg-dark me-2 mb-2">Docker</span>
            <span class="badge bg-secondary me-2 mb-2">AWS</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AboutPage"
};
</script>

<style scoped>
.profile-img {
  max-width: 200px;
  height: 200px;
  object-fit: cover;
  border: 4px solid #fff;
  transition: transform 0.3s ease;
}

.profile-img:hover {
  transform: scale(1.05);
}

.card {
  background: #ffffff;
  transition: box-shadow 0.3s ease;
}

.card:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
}
</style>
